"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChart = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var line_1 = require("@nivo/line");
var lodash_1 = require("lodash");
var UnitFormatter_1 = __importDefault(require("../../../services/UnitFormatter/UnitFormatter"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Skeleton_1 = require("../../atoms/Skeleton/Skeleton");
var Typography_1 = require("../../atoms/Typography/Typography");
var LineChart_logic_1 = require("./LineChart.logic");
/**
 * LineChart molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-linechart--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/LineChart Source}
 */
var LineChart = function (_a) {
    var yAxisFormatter = _a.yAxisFormatter, yFormatter = _a.yFormatter, className = _a.className, _b = _a.mode, mode = _b === void 0 ? 'daily' : _b, data = _a.data, loading = _a.loading, title = _a.title, height = _a.height, width = _a.width, numberOfYTicks = _a.numberOfYTicks, margin = _a.margin;
    var _c = (0, LineChart_logic_1.useLineChart)({ data: data, mode: mode, numberOfYTicks: numberOfYTicks, loading: loading }), classes = _c.classes, isEmpty = _c.isEmpty, randomNumbers = _c.randomNumbers, containerRef = _c.containerRef, tickValuesX = _c.tickValuesX, tickValuesY = _c.tickValuesY, yMax = _c.yMax, xFormat = _c.xFormat, xScale = _c.xScale;
    if (isEmpty) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: className }, { children: [title && (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'headline2' }, { children: title })), loading ? renderSkeleton() : renderChart()] })));
    function renderSkeleton() {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { height: height, width: width }, className: classes.skeletonContainer, ref: containerRef }, { children: [(0, jsx_runtime_1.jsx)(Skeleton_1.Skeleton, { width: '20%', height: "".concat(randomNumbers[0], "%") }), (0, jsx_runtime_1.jsx)(Skeleton_1.Skeleton, { width: '20%', height: "".concat(randomNumbers[1], "%") }), (0, jsx_runtime_1.jsx)(Skeleton_1.Skeleton, { width: '20%', height: "".concat(randomNumbers[2], "%") })] })));
    }
    function renderChart() {
        var _a;
        return ((0, jsx_runtime_1.jsx)("div", __assign({ style: { height: height, width: width }, className: classes.plot, ref: containerRef }, { children: (0, jsx_runtime_1.jsx)(line_1.ResponsiveLine
            // pointLabelYOffset=0 looks the same as undefined but it currently (nivo 0.79.1) throws an runtime error when not set
            , { 
                // pointLabelYOffset=0 looks the same as undefined but it currently (nivo 0.79.1) throws an runtime error when not set
                pointLabelYOffset: 0, data: data, margin: (0, lodash_1.defaults)(margin, { top: 32, right: 24, bottom: 26, left: 72 }), enableGridX: false, xFormat: "time:".concat(xFormat), xScale: xScale, axisBottom: {
                    tickValues: tickValuesX,
                    format: xFormat,
                    tickSize: 0,
                    tickPadding: 12,
                }, enableGridY: true, gridYValues: tickValuesY * 2, yScale: { type: 'linear', min: 'auto', max: yMax || 'auto' }, yFormat: function (value) { return (typeof value === 'number' ? yFormatter(value) : ''); }, axisLeft: {
                    tickValues: tickValuesY,
                    format: yAxisFormatter || yFormatter,
                    tickSize: 0,
                    tickPadding: 16,
                }, enableArea: true, areaOpacity: 1, areaBaselineValue: (0, lodash_1.min)((0, lodash_1.map)((_a = data[0]) === null || _a === void 0 ? void 0 : _a.data, function (_a) {
                    var y = _a.y;
                    return y;
                })), defs: [
                    {
                        id: 'gradient',
                        type: 'linearGradient',
                        colors: [
                            { offset: 0, color: 'rgba(28, 105, 212, 0.7)' },
                            { offset: 100, color: theme_1.default.colors.globalBackgroundLight },
                        ],
                    },
                ], fill: [{ match: '*', id: 'gradient' }], curve: 'monotoneX', lineWidth: 0, pointColor: theme_1.default.colors.dark, pointBorderColor: theme_1.default.colors.globalBackgroundLight, pointBorderWidth: 1.3, theme: {
                    axis: {
                        ticks: {
                            text: __assign(__assign({}, theme_1.default.fonts.label2), { fontFamily: theme_1.default.fontFamily, fill: theme_1.default.textColors.primaryLight, fontWeight: 'bold' }),
                        },
                    },
                }, useMesh: true, tooltip: function (_a) {
                    var data = _a.point.data;
                    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.tooltipContainer }, { children: (0, jsx_runtime_1.jsxs)(Typography_1.Typography, __assign({ variant: 'label1', bold: true, noWrap: true, color: theme_1.default.textColors.highlight }, { children: [data.yFormatted, " ", mode === 'daily' ? 'on' : 'in', ' ', mode === 'daily' ? data.xFormatted : UnitFormatter_1.default.formatMonth(data.x)] })) })));
                } }) })));
    }
};
exports.LineChart = LineChart;
